import Vue from 'vue'
import App from './App.vue'
import './assets/scss/main.scss'
import Buefy from 'buefy'
import VueWaypoint from 'vue-waypoint'

Vue.config.productionTip = false

Vue.use(Buefy)
Vue.use(VueWaypoint)
new Vue({
  render: h => h(App),
}).$mount('#app')
